import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async create ({ state, dispatch }) {
    try {
      const files = await directus.getFiles({
        filter: {
          'metadata': {
            contains: 'no_image'
          }
        }
      })

      await directus.createItem('member_seating_status', {
        now: 1,
        memo: '',
        user: {
          status: 'active',
          role: 1,
          first_name: state.firstName,
          last_name: state.lastName,
          email: state.email,
          password: state.password,
          locale: 'ja-JP',
          timezone: 'Asia/Tokyo',
          avatar: files.data[0].id
        }
      })
      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
